const pad = (value: number) => String(value).padStart(2, "0");

/** 相对时间描述，数据为静态示范内容，以当前日期为基准 */
export function formatRelativeDate(date: string): string {
  const target = new Date(`${date}T09:00:00`);
  const now = new Date();
  const diffDays = Math.floor((now.getTime() - target.getTime()) / 86400000);

  if (diffDays <= 0) return "今天";
  if (diffDays === 1) return "昨天";
  if (diffDays < 7) return `${diffDays} 天前`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} 周前`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} 个月前`;
  return date;
}

/** 2026-10-15 -> 2026.10.15 */
export function formatDotDate(date: string): string {
  return date.replace(/-/g, ".");
}

/** 2026-10-15 -> 10 月 15 日 */
export function formatChineseDate(date: string): string {
  const [, month, day] = date.split("-");
  return `${Number(month)} 月 ${Number(day)} 日`;
}

export function formatNumber(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)} 万`;
  return String(value);
}

export function formatClock(seconds: number): string {
  return `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
}

export { pad };